import React, { useEffect, useState } from 'react';
import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;
const fileUrl = process.env.REACT_APP_IMAGE_URL;

const Download = () => {
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const downloadsUrl = `${baseUrl}/downloads/`;

  const buildAssetUrl = (path) => {
    if (!path) return '';
    const normalizedBase = (fileUrl || '').replace(/\/$/, '');
    const normalizedPath = String(path).startsWith('/') ? path : `/${path}`;
    return `${normalizedBase}${normalizedPath}`;
  };

  const formatDate = (value) => {
    if (!value) return 'N/A';
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? 'N/A' : parsed.toLocaleDateString();
  };

  useEffect(() => {
    setLoading(true);
    setError('');

    axios.get(downloadsUrl)
      .then(response => {
        setDownloads(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching the downloads!", error);
        setError('Unable to load downloads right now.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [downloadsUrl]);

  return (
    <div className="container my-4">
      <h2 className="mb-4 text-center">Downloadable Files</h2>

      {loading && <p className="text-center">Loading downloads...</p>}
      {!loading && error && <p className="text-center text-danger">{error}</p>}
      {!loading && !error && downloads.length === 0 && (
        <p className="text-center">No downloadable files available.</p>
      )}

      <div className="row justify-content-center">
        {downloads.map((download) => (
          <div className="mb-3 card" key={download.id} style={{ maxWidth: '1200px', height: '200px', borderRadius: '50px 0 50px 0' }}>
            <div className="row g-0 h-100">
              <div className="col-md-3 h-100">
                {download.cover ? (
                  <img src={buildAssetUrl(download.cover)} className="img-fluid h-100" alt={download.title} style={{ objectFit: 'cover', borderRadius: '50px 0 50px 0' }} />
                ) : (
                  <div className="d-flex align-items-center justify-content-center h-100" style={{ borderRadius: '50px 0 50px 0' }}>
                    No cover
                  </div>
                )}
              </div>
              <div className="col-md-8">
                <div className="card-body">
                  <h5 className="card-title">{download.title}</h5>
                  <p className="card-text">{download.description}</p>
                  <p className="text-sm text-gray-500">{formatDate(download.created_at)}</p>
                </div>
              </div>
              <div className="col-md-1 d-flex align-items-center">
                <a href={buildAssetUrl(download.file)} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                  Download
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Download;